var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""}},on),[_c('v-icon',[_vm._v(" mdi-dots-vertical ")])],1)]}}])},[_c('v-list',[_c('px-aprovacao-solicitacao-geracao-parcial-dialog',{attrs:{"aprovacao-id":_vm.aprovacao.id},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-content',[_vm._v("Gerar solicitação parcial")])],1)]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }